import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/saint-tms-cost")({
  beforeLoad: () => {
    throw redirect({ to: "/learn/saint-tms-cost", statusCode: 301 });
  },
});
